import React from 'react';
type ButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  /** All primary CTAs are green. 'ink' stays available for rare secondary actions. */
  variant?: 'go' | 'ink';
  className?: string;
  ariaLabel?: string;
};
const variants: Record<'go' | 'ink', string> = {
  go: 'bg-go text-white shadow-go hover:bg-goDark active:bg-[#15803D]',
  ink: 'bg-ink text-white shadow-paper hover:bg-[#1E293B] active:bg-[#0B1220]'
};
export function Button({
  children,
  onClick,
  variant = 'go',
  className = '',
  ariaLabel
}: ButtonProps) {
  return <button type="button" onClick={onClick} aria-label={ariaLabel} className={`focus-ring flex h-[58px] w-full items-center justify-center rounded-card px-6 text-center font-display text-[17px] font-extrabold uppercase tracking-[0.06em] transition-colors duration-150 sm:text-[18px] ${variants[variant]} ${className}`} data-id="element-36" data-mp="2d1o0jakj40iq">
      {children}
    </button>;
}